var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('click', $event)}}},'v-btn',_vm.$attrs,false),on),[_c('v-icon',[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)]}}])},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }